/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import { withRouter } from "react-router-dom"; // Import withRouter HOC
import PropTypes from "prop-types";
import "./OrgPlanSelection.css";
// Assuming a common header/logo component exists or create a simple one
// import OrgHeader from '../shared/OrgHeader'; // Example path

// Receive history from props injected by withRouter
const OrgPlanSelectionComponent = ({ languageObj, history }) => {
  // const history = useHistory(); // Remove hook call

  const handleSelectFreeTier = () => {
    // console.log("Selected Free Tier");
    // Navigate to the signup form, indicating 'free' plan choice
    history.push({
      pathname: "/OrgSignup",
      state: { planType: "free" },
    });
  };

  const handleBuildCustomPlan = () => {
    // console.log("Selected Build Custom Plan");
    // Navigate to the plan builder route first
    history.push("/org/register/build-plan");
    // Note: The Plan Builder will later navigate to /OrgSignup after configuration
  };

  // Placeholder language strings - replace with actual languageObj properties
  const lang = languageObj || {
    pageTitle: "Choose Your Starting Point",
    freeTierTitle: "Explore Free Tier",
    freeTierDescription:
      "Get started with essential features at no cost. Ideal for new organizations.",
    freeTierButton: "Start with Free",
    customPlanTitle: "Build Your Custom Plan",
    customPlanDescription:
      "Tailor a plan with the exact features your organization needs. Select add-ons and see pricing instantly.",
    customPlanButton: "Build Custom Plan",
    checkplusLogoAlt: "CheckPlus Logo",
  };

  return (
    <div className="OrgPlanSelection-view">
      {/* <OrgHeader /> */}
      <div className="OrgPlanSelection-header">
        {/* Simple Logo Placeholder */}
        <div
          className="OrgPlanSelection-logo"
          alt={lang.checkplusLogoAlt}
        ></div>
      </div>

      <div className="OrgPlanSelection-content">
        <h1>{lang.pageTitle}</h1>

        <div className="OrgPlanSelection-optionsContainer">
          {/* Option 1: Free Tier */}
          <div className="OrgPlanSelection-optionCard">
            <h2>{lang.freeTierTitle}</h2>
            <p>{lang.freeTierDescription}</p>
            <button
              className="OrgPlanSelection-button OrgPlanSelection-button-primary"
              onClick={handleSelectFreeTier}
            >
              {lang.freeTierButton}
            </button>
          </div>

          {/* Option 2: Build Custom Plan */}
          <div className="OrgPlanSelection-optionCard">
            <h2>{lang.customPlanTitle}</h2>
            <p>{lang.customPlanDescription}</p>
            <button
              className="OrgPlanSelection-button OrgPlanSelection-button-secondary"
              onClick={handleBuildCustomPlan}
            >
              {lang.customPlanButton}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Update PropTypes to match the new component name and include history
OrgPlanSelectionComponent.propTypes = {
  languageObj: PropTypes.object,
  history: PropTypes.object.isRequired, // history is required by withRouter
};

// Wrap the component with withRouter before exporting
export default withRouter(OrgPlanSelectionComponent);
